import React, { useState, useEffect, useLayoutEffect, useContext } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  insertIlustrationSignature,
  insertSelfie,
  checkSelfieSignature
} from "../../store/features/CameraAndSignatureSlice";
import {
  Accordion,
  Form,
  Modal,
  Row,
  Col,
  useAccordionButton,
  Card,
  AccordionContext,
} from "react-bootstrap";
import styles from "./PersetujuanPage.module.css";
import Webcam from "react-webcam";
import Header from "../../component/Header/header";
import ProgressBar from "../../component/ProgressBar/progressbar";
import SignatureCanvas from "react-signature-canvas";
import { StatusCustomer, getToday, getTime } from "../../component/Helper";
import {
  updateStatusSpaj,
  updateStatusCustomer,
} from "../../store/features/SPAJSlice";
import Spinners from "../../component/Spinner/spinners";
import {
  getIlustrationSignature,
  getSelfie,
} from "../../store/features/CameraAndSignatureSlice";
import { Cpu } from "react-bootstrap-icons";
import LockScreen from '../../component/LockScreen/lockscreen';


export const SigLocContext = React.createContext({
  dataSigLoc: [],
  setDataSigLoc: () => [],
});

const checkButtonLanjut = (dataSigLoc, dataSigna, imageSrc, dataSignature, dataSelfie, setButtonLanjut) => {
  let buttonLanjut = true;
  console.log("dataSigna ", dataSigna)
  dataSignature.forEach((row, index) => {
    let selfie = dataSelfie.find(
      (row2) => row.clientNumber == row2.clientNumber
    );
    if (row.clientCode !== "AG") {
      // check location
      if (row.locationSignature == "") {
        if (
          dataSigLoc[index] == undefined ||
          dataSigLoc[index].location == ""
        ) {
          buttonLanjut = false;
        }else if(row.isDone == '0'){
          console.log("masuk sini 1 ", dataSigna[index]?.failedConfirmation);
          if(dataSigna[index]?.failedConfirmation == true || dataSigna[index]?.failedConfirmation == undefined){
            buttonLanjut = false;
          }
        }
      }else if(row.isDone == '0'){
        console.log("masuk sini 2 ", dataSigna[index]?.failedConfirmation);
        if(dataSigna[index]?.failedConfirmation == true || dataSigna[index]?.failedConfirmation == undefined){
          buttonLanjut = false;
        }
      }
      // check signature
      if (row.imageSignature == "") {
        if (
          dataSigna[index] == undefined ||
          dataSigna[index].datas == false ||
          dataSigna[index].datas == ""
        ) {
          buttonLanjut = false;
        }else if(row.isDone == '0'){
          console.log("masuk sini 3 ", dataSigna[index]?.failedConfirmation);
          if(dataSigna[index]?.failedConfirmation == true || dataSigna[index]?.failedConfirmation == undefined){
            buttonLanjut = false;
          }
        }
      }else if(row.isDone == '0'){
        if(dataSigna[index]?.failedConfirmation == true || dataSigna[index]?.failedConfirmation == undefined){
          buttonLanjut = false;
        }
      }

      // check selfie
      if (
        row.clientCode !== "C1" &&
        row.clientCode !== "C2" &&
        row.clientCode !== "C3" &&
        row.clientCode !== "C4"
      ) {
        if (selfie != null && selfie != undefined) {
          if (selfie.imageSelfie == "") {
            if (imageSrc[index] == undefined || imageSrc[index].image == "") {
              buttonLanjut = false;
            }else if(row.isDone == '0'){
              console.log("masuk sini 4 ", dataSigna[index]?.failedConfirmation);
              if(dataSigna[index]?.failedConfirmation == true || dataSigna[index]?.failedConfirmation == undefined){
                buttonLanjut = false;
              }
            }
          }else if(row.isDone == '0'){
            if(dataSigna[index]?.failedConfirmation == true || dataSigna[index]?.failedConfirmation == undefined){
              buttonLanjut = false;
            }
          }
        }
      }
    }
  });

  return setButtonLanjut(buttonLanjut);
};

const sendSignatureSelfie = async (
  location,
  signSrc,
  imageSrc,
  data,
  DeviceId,
  SPAJDetail,
  insertSignature,
  insertSelfieWrap,
  time,
  setLoading,
  setShowHide,
  buttonLanjut,
  index,
  setDataDisableKonfirmasi,
  setShowHideError,
  setButtonLanjut,
  dataSigna,
  setDataSigna,
  selfie,
  dataCountTtd,
  setDataCountTtd,
  dataSigLoc,
  checkButtonLanjut,
  dataSignature,
  dataSelfieRaw,
  imageSrcRaw,
  setErrorMessage
) => {

  let data1,
    data2 = false;

    let skipPIUnderAge = true
    if(data.clientCode == "PI")
    {
      if( SPAJDetail.dataPI.TCLN_Age < 18)
      {
        skipPIUnderAge =  false
      }
    }
    
  if (
    (location == undefined || location == "") &&
    (data.locationSignature == undefined || data.locationSignature == "")
  ) {
    return alert("Lokasi harus di isi");
  }
  if (data.isDone == "0" && signSrc.signImg ==="") {
    return alert("Tanda tangan harus di isi");
  }
  if (
    data.clientCode != "C1" &&
    data.clientCode != "C2" &&
    data.clientCode != "C3" &&
    data.clientCode != "C4"
  ) {

    if(skipPIUnderAge)
    {
      if (imageSrc == undefined || imageSrc == "") {
        return alert("Selfie harus di isi");
      }
    }
    
  }

  if (location == undefined || location == "") {
    location = { location: data.locationSignature };
  }
console.log("time",time)
  if (data.isDone == "0") {
    let dataSignature = {
      deviceId: `${DeviceId.deviceId}`,
      agentCode: data.agentCode,
      leadNumber: `${SPAJDetail.dataPH.TCLN_LeadNumber}`,
      spajNumber: `${SPAJDetail.dataSpaj.spajNumber}`,
      clientCode: data.clientCode,
      clientNumber: data.clientNumber,
      documentId: "SPAJ",
      location: location.location,
      signatureDate: time.time.split(" ")[0], //hanya ambil tanggal saja
      clientSignature: signSrc.signImg,
      userName: `${SPAJDetail.dataSpaj.email}`,
    };
    setLoading(true);
    await insertSignature(dataSignature).then((res) => {
      setLoading(false);
      data1 = true;
      dataSigna[index].confirmedSignature = true;
      dataCountTtd[index].button = false;
      if (res.payload.status == "ERROR") {
        dataSigna[index].confirmedSignature = false;
        dataCountTtd[index].button = true;
        data1 = false;
        setErrorMessage(res.payload.errMsg);
      } else {
        // try {
        //   canvas.off();
        // } catch (e) {}
      }
      setDataCountTtd(dataCountTtd);
      setDataSigna({ ...dataSigna });
    });
  } else {
    data1 = true;
  }

  if (selfie != undefined && selfie.isDone == "0") {
    if (
      data.clientCode != "C1" &&
      data.clientCode != "C2" &&
      data.clientCode != "C3" &&
      data.clientCode != "C4"
    ) {
      var dataSelfie = new FormData();
      dataSelfie.append(
        "selfImage",
        imageSrc.image.split("data:image/jpeg;base64,")[1]
      );
      dataSelfie.append("deviceId", `${DeviceId.deviceId}`);
      dataSelfie.append("agentCode", `${data.agentCode}`);
      dataSelfie.append("leadNumber", `${SPAJDetail.dataPH.TCLN_LeadNumber}`);
      dataSelfie.append("clientNumber", data.clientNumber);
      dataSelfie.append(
        "illustrationNumber",
        `${SPAJDetail.dataSpaj.illustrationNumber}`
      );
      dataSelfie.append("spajNumber", `${SPAJDetail.dataSpaj.spajNumber}`);
      dataSelfie.append("sequenceNumber", "1");
      dataSelfie.append("userName", `${SPAJDetail.dataSpaj.email}`);
      dataSelfie.append("fileSource", "CAM");
      setLoading(true);
      await insertSelfieWrap(dataSelfie).then((res) => {
        setLoading(false);
        data2 = true;
        dataSigna[index].confirmedSelfie = true;
        if (res.payload.data.status == "ERROR") {
          data2 = false;
          dataSigna[index].confirmedSelfie = false;
          dataSigna[index].dataSelfie = false;
          setErrorMessage(res.payload.data.errMsg);
        }
        setDataSigna({ ...dataSigna });
      });
    } else {
      data2 = true;
    }
  } else {
    data2 = true;
  }
  if (data1 && data2) {
    setShowHide(true);
    setDataDisableKonfirmasi((oldState) => ({
      ...oldState,
      [index]: {
        button: true,
      },
    }));
    dataSigna[index].failedConfirmation = false;
    setDataSigna({ ...dataSigna });
  } else {
    dataSigna[index].failedConfirmation = true;
    setDataSigna({ ...dataSigna });
    setShowHideError(true);
    setButtonLanjut(false);
  }
  checkButtonLanjut(dataSigLoc, dataSigna, imageSrcRaw, dataSignature, dataSelfieRaw, setButtonLanjut);
};

//SIGNATURE FUNCTION
// function useWindowSize() {
//   const [size, setSize] = useState([0, 0]);
//   useLayoutEffect(() => {
//     function updateSize() {
//       window.innerWidthReal = window.innerWidth * 0.45;
//       window.innerHeightReal = window.innerHeight * 0.15;

//       setSize([window.innerWidthReal, window.innerHeightReal]);
//     }
//     window.addEventListener("resize", updateSize);
//     updateSize();
//     return () => window.removeEventListener("resize", updateSize);
//   }, []);
//   return size;
// }
const MOBILE_WIDTH = 576;


const checkTertanggung = (data) => {
  if (data == 0) {
    return "Agent";
  } else if (data == 1) {
    return "Pemegang Polis";
  } else if (data == 2) {
    return "Tertanggung Utama";
  } else {
    return "Tertanggung Tambahan " + (data - 2);
  }
};


// We lazy-load react-select to avoid errors if dependency not yet installed.
let CreatableSelectRef;
try {
  // eslint-disable-next-line global-require
  CreatableSelectRef = require('react-select/creatable').default;
} catch (e) {
  CreatableSelectRef = null; // Will show fallback input until dependency installed.
}

const sanitizeLocationInput = (val) => (val || '').replace(/[^a-z ,]/gi,'');

const LocationText = ({
  index,
  locationSig,
  dataSigna,
  checkButtonLanjut,
  imageSrc,
  checkButtonKonfirmasi,
  dataDisableKonfirmasi,
}) => {
  const { CitySign } = useSelector((state) => state.CitySign);
  const { dataSigLoc, setDataSigLoc } = useContext(SigLocContext);

  // --- City options for react-select (extend as needed) ---
  const CITY_OPTIONS = (CitySign && CitySign.length > 0
    ? CitySign
    : [
        "KOTA ADM. JAKARTA BARAT","KOTA ADM. JAKARTA PUSAT","KOTA ADM. JAKARTA SELATAN","KOTA ADM. JAKARTA TIMUR","KOTA ADM. JAKARTA UTARA","KOTA SURABAYA","KAB. BANDUNG","KAB. BANDUNG BARAT","KOTA BANDUNG","KOTA MEDAN","KAB. SEMARANG","KOTA SEMARANG","KOTA YOGYAKARTA","KOTA DENPASAR","KOTA MAKASSAR","KOTA PALEMBANG","KAB. BOGOR","KOTA BOGOR","KOTA DEPOK","KAB. BEKASI","KOTA BEKASI","KAB. TANGERANG","KOTA TANGERANG","KOTA TANGERANG SELATAN"
      ].map(c => ({ value: c, label: c }))
  );

  const disabled = (
    locationSig !== "" ||
    dataDisableKonfirmasi[index].button ||
    dataSigna[index]?.confirmedSignature === true ||
    dataSigna[index]?.confirmedSelfie === true
  );

  const currentLocation = dataSigLoc[index]?.location || locationSig || '';
  const currentOption = currentLocation ? { value: currentLocation, label: currentLocation } : null;

  const handleSelectChange = (selectedOption) => {
    setDataSigLoc((oldState) => ({
      ...oldState,
      [index]: { location: selectedOption ? sanitizeLocationInput(selectedOption.value) : '' }
    }));
    checkButtonKonfirmasi(dataSigLoc, dataSigna, imageSrc, index);
  };

  const handleInputChange = (inputValue) => sanitizeLocationInput(inputValue);

  // Fallback to normal input if react-select not installed yet
  if (!CreatableSelectRef) {
    return (
      <>
      <Form>
        <Form.Group className="mb-3" controlId="formSign">
          <Form.Label className="text-label">Ditandatangani di (Kota / Kabupaten anda)</Form.Label>
          <Form.Control
            value={currentLocation}
            type="text"
            onChange={(e) => {
              setDataSigLoc((oldState) => ({
                ...oldState,
                [index]: { location: sanitizeLocationInput(e.target.value) }
              }));
              checkButtonKonfirmasi(dataSigLoc, dataSigna, imageSrc, index);
            }}
            disabled={disabled}
            placeholder="Ketik Kota / Kabupaten"
          />
        </Form.Group>
      </Form>
      </>
    );
  }

  const CreatableSelect = CreatableSelectRef;

  return (
    <Form>
      <Form.Group className="mb-3" controlId="formSign">
        <Form.Label className="text-label">Ditandatangani di (Kota / Kabupaten anda)</Form.Label>
        <CreatableSelect
          isDisabled={disabled}
          value={currentOption}
          onChange={handleSelectChange}
          onInputChange={handleInputChange}
          options={CITY_OPTIONS}
          placeholder="Pilih Kota / Kabupaten"
          isClearable
          formatCreateLabel={(inputValue) => CITY_OPTIONS.some(option => option.label.toLowerCase().includes(inputValue.toLowerCase())) ? null : `Tambah: ${inputValue}` }
          styles={{
            control: (base, state) => ({
              ...base,
              minHeight: '38px',
              borderColor: state.isFocused ? '#dc3545' : base.borderColor,
              boxShadow: 'none',
            }),
          }}
        />
      </Form.Group>
    </Form>
  );
};

function ReturnSelfie({ imageSrc, dataSelfie }) {
  if (imageSrc != undefined) {
    if (imageSrc.image == "") {
      return <div><img src={"/images/icon-selfie.png"} width={40} height={70} />
      <div className="mt-15">
        Upload foto selfie mohon tidak menggunakan masker dan kacamata hitam
      </div>
    </div>;
    }
    return <img src={imageSrc.image} className={styles.selfieContent} style={{ maxWidth: '100%', maxHeight: '200px', objectFit: 'contain', width: 'auto', height: 'auto' }}/>;
  } else if (dataSelfie != "") {
    return (
      <img
        src={"data:image/png;base64," + dataSelfie}
        className={styles.selfieContent}
        style={{ maxWidth: '100%', maxHeight: '200px', objectFit: 'contain', width: 'auto', height: 'auto' }}
      />
    );
  } else {
    return <div><img src={"/images/icon-selfie.png"} width={40} height={70} />
        <div className="mt-15">
          Upload foto selfie mohon tidak menggunakan masker dan kacamata hitam
        </div>
      </div>
    ;
  }
}

function ReturnSign({ signSrc, dataSign }) {
  console.log("signSrc",signSrc)
  if (signSrc != undefined) {
    if (signSrc.signImg ==="") {
      return null;
    }
    return <img src={"data:image/png;base64," +signSrc.signImg} className={styles.imgtandatangan}/>;
  } else if (dataSign != "") {
    return (
      <img
        src={"data:image/png;base64," + dataSign}
        className={styles.imgtandatangan}
      />
    );
  } else {
    return null ;
  }
}

function ReturnDataTTD({
  dataSignature,
  dataSelfie,
  setImageIndex,
  imageIndex,
  setImageSrc,
  imageSrc,
  insertSignature,
  insertSelfieWrap,
  setLoading,
  setErrorMessage,
  setShowHide,
  buttonLanjut,
  setButtonLanjut,
  dataCountTtd,
  setDataCountTtd,
  dataDisableKonfirmasi,
  setDataDisableKonfirmasi,
  setShowHideError,
  setSignIndex,
  signIndex,
  signSrc,
  setSignSrc
}) {
  const { SPAJs } = useSelector((state) => state.SPAJs);
  const { CitySign } = useSelector((state) => state.CitySign);
  const [dataSigLoc, setDataSigLoc] = useState([]);
  const [dataSigna, setDataSigna] = useState({});
  const [Signa, setSigna] = useState(null);
  const value = { dataSigLoc, setDataSigLoc };
  // const [widthss, heightss] = useWindowSize();
  // const canvaswidth = widthss * 0.93;
  // const canvasheight = heightss * 0.85;
  const { DeviceId } = useSelector((state) => state.DeviceId);
  const { SPAJDetail } = useSelector((state) => state.SPAJsDetail);

  const sigCanvas = new Map();
  const signRef = React.useRef(null);
  const webcamRef = React.useRef(null);
  let [showCamera, setShowCamera] = useState(false);
  let [showCanvas, setShowCanvas] = useState(false);

//   useEffect(() => {
//     console.log("SIGNATURE ", dataSignature);
//   }, []);

  useEffect(() => {
    // checkButtonLanjut(dataSigLoc, dataSigna, imageSrc);
      checkButtonKonfirmasi(dataSigLoc, dataSigna, imageSrc, imageIndex);
  }, [imageSrc]);

  const checkButtonKonfirmasi = (
    dataSigLoc,
    dataSigna,
    imageSrc,
    indexCome
  ) => {
    let buttonKonfirmasi = true;
    dataSignature.forEach((row, index) => {
      let selfie = dataSelfie.find(
        (row2) => row.clientNumber == row2.clientNumber
      );
      if (row.clientCode !== "AG") {
        // check location
        if (row.locationSignature == "" && index == indexCome) {
          if (
            dataSigLoc[index] == undefined ||
            dataSigLoc[index].location == ""
          ) {
            buttonKonfirmasi = false;
          }
        }
        // check signature
        if (row.imageSignature == "" && index == indexCome) {
          if (
            dataSigna[index] == undefined ||
            dataSigna[index].datas == false ||
            dataSigna[index].datas == ""
          ) {
            buttonKonfirmasi = false;
          }
        }

        // check selfie
        if (
          row.clientCode !== "C1" &&
          row.clientCode !== "C2" &&
          row.clientCode !== "C3" &&
          row.clientCode !== "C4"
        ) {
          if (selfie != null && selfie != undefined) {
            if (selfie.imageSelfie == "" && index == indexCome) {
              if (imageSrc[index] == undefined || imageSrc[index].image == "") {
                buttonKonfirmasi = false;
              }
            }
          }
        }
      }
    });


    return setDataCountTtd((oldState) => ({
      ...oldState,
      [indexCome]: {
        button: buttonKonfirmasi,
      },
    }));
  };

  const getSign = (idx, data, validation) => {
    if (!validation) {
      setSignIndex(idx);
      setShowCanvas(true);
    }
  };

  const updateStateSign = (data) => {
    setSignIndex(data);
    setShowCanvas(false);
  };

  const captureSign = React.useCallback(() => {
    const dataSign = signRef.current.toDataURL().split("data:image/png;base64,")[1];
    if(signRef.current.isEmpty() == false){
      handleEnd(signIndex)

      setSignSrc((oldState) => ({
        ...oldState,
        [signIndex]: {
          signImg: dataSign,
        },
      }));

      updateStateSign(dataSign)

    }else{
      setShowCanvas(true);
    }
  }, [signRef, signIndex,signSrc]);

  // CAMERA FUNCTION
  const getSelfie = (idx, data, validation) => {
    if (!validation) {
      setImageIndex(idx);
      setShowCamera(true);
    }
  };

  const updateStateImage = (data) => {
    setImageIndex(data);
    setShowCamera(false);
  };

  const capture = React.useCallback(() => {
    const dataImage = webcamRef.current.getScreenshot();
    if(dataImage !== null){
      setImageSrc((oldState) => ({
        ...oldState,
        [imageIndex]: {
          image: dataImage,
        },
      }));

      if (!dataSigna[imageIndex]) {
        dataSigna[imageIndex] = {};
      }
      dataSigna[imageIndex].dataSelfie = true;
      setDataSigna({ ...dataSigna });

      updateStateImage(dataImage);
    }else{
      setShowCamera(false);
    }
  }, [webcamRef, imageSrc, imageIndex, dataSigna]);

  const handleEnd = (index) => {
    if (!dataSigna[index]) {
      dataSigna[index] = {};
      dataSigna[index].datas = true;
    }
    dataSigna[index].time = getToday() + " " + getTime();
    if ((dataSigna[index].datas = true)) {
      setDataSigna({ ...dataSigna });
    }
    setSigna(index);
    // checkButtonLanjut(dataSigLoc, dataSigna, imageSrc);
    // console.log(dataSigLoc, dataSigna, imageSrc,"<imageSRC", index,"<<<ahopiw")
    checkButtonKonfirmasi(dataSigLoc, dataSigna, imageSrc, index);
  };

  const clearSignature = (index) => {
    if (
      signSrc[index] != undefined &&
      !dataDisableKonfirmasi[index].button
    ) {
      setSignSrc((oldState) => ({
        ...oldState,
        [index]: {
          signImg: "",
        },
      }));
      dataSigna[index].datas = false;
      dataSigna[index].time = "";
      setDataSigna({ ...dataSigna });
    }
    // checkButtonLanjut(dataSigLoc, dataSigna, imageSrc);
    checkButtonKonfirmasi(dataSigLoc, dataSigna, imageSrc, index);
  };

  const clearImage = (index, selfie, setButtonLanjut) => {
    if (dataSigna[index] != undefined && !dataDisableKonfirmasi[index].button) {
      setImageSrc((oldState) => ({
        ...oldState,
        [index]: {
          image: "",
        },
      }));
      dataSigna[index].dataSelfie = false;
      setDataSigna({ ...dataSigna });
    }
    // checkButtonLanjut(dataSigLoc, dataSigna, imageSrc);
    checkButtonKonfirmasi(dataSigLoc, dataSigna, imageSrc, index);
  };

  const checkDisabledKonfirmasi = (index, row, selfie) => {

    if (row.isDone == "1" && (selfie == undefined || selfie == null)) {
      return true;
    } else if (row.isDone == "1" && selfie.isDone == "1") {
      return true;
    }

    if (dataCountTtd[index].button) {
      if (
        selfie == undefined ||
        selfie == null ||
        dataSigna[index]?.dataSelfie == true
      ) {
        if (dataSigLoc[index]?.location != "") {
          return false;
        }
        return true;
      } else {
        return true;
      }
    }

    if (
      dataSigna[index]?.datas == true &&
      dataSigna[index]?.dataSelfie == true &&
      dataSigLoc[index] !== undefined
    ) {
      if (
        dataSigna[index]?.confirmedSignature == true ||
        dataSigna[index]?.confirmedSelfie == true
      ) {
        return true;
      } else {
        if (dataSigLoc[index]?.location != "") {
          return false;
        } else {
          return true;
        }
      }
    } else {
      if (dataSigna[index]?.dataSelfie == true) {
        if (dataSigna[index]?.datas == false) {
          return true;
        }
        if (dataSigna[index]?.confirmedSelfie == true) {
          return true;
        }
      } else {
        return true;
      }
    }
  };

  const checkDisabledButtonDeletTtd = (index, row) => {
    if (row.isDone == "1") {
      return true;
    }
    if (dataCountTtd[index].button) {
      if (dataSigna[index]?.confirmedSignature == true) {
        return true;
      }
      return false;
    }
    if (
      dataSigna[index]?.datas == true &&
      dataSigLoc[index] !== undefined &&
      dataSigLoc[index]?.location != ""
    ) {
      if (dataSigna[index]?.confirmedSignature == true) {
        return true;
      }
      return false;
    }
  };

  let arrayString = [];
  let dataAG = {};


  dataSignature.forEach((row, index) => {

    if (row.clientCode !== "AG") {
      let selfie = dataSelfie.find(
        (row2) => row.clientNumber == row2.clientNumber
      );
      let string = (
        <div key={index}>
          <div className={`bold`}>
            Tanda Tangan {checkTertanggung(parseInt(row.seq))} ({row.firstName})
          </div>
          <div>
            <Row>
              <Col xs={12} sm={6} md={7} lg={6} xl={5} style={{marginBottom:10}}>
                <div className={styles.formLokasi}>
                    <SigLocContext.Provider value={value}>
                    <LocationText
                        index={index}
                        locationSig={row.locationSignature}
                        dataSigna={dataSigna}
                        imageSrc={imageSrc}
                        checkButtonLanjut={checkButtonLanjut}
                        checkButtonKonfirmasi={checkButtonKonfirmasi}
                        dataDisableKonfirmasi={dataDisableKonfirmasi}
                    />
                    </SigLocContext.Provider>
                </div>
                <div className={`d-flex flex-column justify-content-start`}>
                  <div className={`${styles.containerTtd}`}>
                    <div className={`${styles.sigContainer}`}
                        onClick={() =>
                          getSign(
                            index,
                            selfie,
                            checkDisabledButtonDeletTtd(index, row)
                          )
                    }>

                        <ReturnSign
                          signSrc={signSrc[index]}
                          dataSign={row.imageSignature }
                        />
                      <div
                        style={{
                          textAlign: "center",
                          position: "absolute",
                          bottom: 5,
                          left: 0,
                          right: 0,
                        }}
                      >
                        {row.firstName}
                      </div>
                    </div>
                  </div>
                  <div style={{ marginTop:5 }}>
                    <button
                      disabled={checkDisabledButtonDeletTtd(index, row)}
                      onClick={() => clearSignature(index)}
                    >
                      {" "}
                      <img
                        src={
                          checkDisabledButtonDeletTtd(index, row)
                            ? "/images/deleteGrey.png"
                            : "/images/delete.png"
                        }
                        width="25"
                      />
                    </button>
                  </div>
                </div>
              </Col>
              <Col xs={12} sm={6} md={5} lg={6} xl={7}>
                {selfie == null || selfie == undefined ? (
                  ""
                ) : (
                  <div
                   className={`d-flex flex-column justify-content-start`}
                  >
                    <div>
                      <div className="text-label mb-10" >Upload Foto Selfie</div>
                      <div
                        className={`${styles.buttonUpload}`}
                        onClick={() =>
                          getSelfie(
                            index,
                            selfie,
                            dataDisableKonfirmasi[index].button
                              ? true
                              : dataCountTtd[index].button
                              ? false
                              : dataSigna[index]?.datas == true &&
                                dataSigna[index]?.dataSelfie == true &&
                                dataSigLoc[index] !== undefined &&
                                dataSigLoc[index]?.location != ""
                              ? false
                              : selfie.isDone == "1"
                              ? true
                              : false
                          )
                        }
                      >
                        <ReturnSelfie
                          imageSrc={imageSrc[index]}
                          dataSelfie={selfie.imageSelfie}
                        />
                      </div>
                    </div>
                    <div style={{ marginTop:5 }}>
                      {/* <button disabled={(dataCountTtd[index].button) ? false : (dataSigna[index]?.datas == true && dataSigna[index]?.dataSelfie == true && dataSigLoc[index] !== undefined && dataSigLoc[index]?.location != "") ? false : (selfie.isDone == '1' || dataSigna[index]?.confirmedSelfie == true ? true : false)} onClick={() => clearImage(index, selfie.imageSelfie, setButtonLanjut)}><img src={(dataCountTtd[index].button) ? '/images/delete.png' : (dataSigna[index]?.dataSelfie == true) ? (dataSigna[index]?.confirmedSelfie == true ? '/images/deleteGrey.png' : '/images/delete.png') : (selfie.isDone == '1' ? '/images/deleteGrey.png' : '/images/delete.png')} width="35" /></button> */}
                      <button
                        disabled={
                          dataCountTtd[index].button
                            ? false
                            : dataSigna[index]?.dataSelfie == true
                            ? dataSigna[index]?.confirmedSelfie == true
                              ? true
                              : false
                            : selfie.isDone == "1"
                            ? true
                            : false
                        }
                        onClick={() =>
                          clearImage(index, selfie.imageSelfie, setButtonLanjut)
                        }
                      >
                        <img
                          src={
                            dataCountTtd[index].button
                              ? "/images/delete.png"
                              : dataSigna[index]?.dataSelfie == true
                              ? dataSigna[index]?.confirmedSelfie == true
                                ? "/images/deleteGrey.png"
                                : "/images/delete.png"
                              : selfie.isDone == "1"
                              ? "/images/deleteGrey.png"
                              : "/images/delete.png"
                          }
                          width="25"
                        />
                      </button>
                    </div>
                  </div>
                )}
              </Col>
            </Row>

          </div>
          <div className="mt-2">
            <div style={{ marginBottom: 5 }}>{dataSigna[index]?.time}</div>
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                marginTop: 25,
              }}
            >
              <button
                type="button"
                className={
                  checkDisabledKonfirmasi(index, row, selfie)
                    ? `${styles.buttonkirimDisable}`
                    : `${styles.buttonkirim}`
                }
                disabled={checkDisabledKonfirmasi(index, row, selfie)}
                onClick={() => {
                  sendSignatureSelfie(
                    dataSigLoc[index],
                    signSrc[index],
                    imageSrc[index],
                    row,
                    DeviceId,
                    SPAJDetail,
                    insertSignature,
                    insertSelfieWrap,
                    dataSigna[index],
                    setLoading,
                    setShowHide,
                    buttonLanjut,
                    index,
                    setDataDisableKonfirmasi,
                    setShowHideError,
                    setButtonLanjut,
                    dataSigna,
                    setDataSigna,
                    selfie,
                    dataCountTtd,
                    setDataCountTtd,
                    dataSigLoc,
                    checkButtonLanjut,
                    dataSignature,
                    dataSelfie,
                    imageSrc,
                    setErrorMessage
                  );
                }}
              >
                Konfirmasi
              </button>
            </div>
          </div>
          <br />
        </div>
      );
      arrayString.push(string);
    } else {
      dataAG = row;
    }
  });

  let stringAG = (
    <div key={99999}>
      <div className={`bold`}>Tanda Tangan Agent ({dataAG.firstName})</div>
      <Row>
        <Col xs={12} sm={12} md={9} lg={7}>
            <Form>
              <Form.Group
                className={`mb-3 ${styles.formLokasi}`}
                controlId="formSign"
              >
                <Form.Label className="text-label">Ditandatangani di (kota anda)</Form.Label>
                <Form.Control
                  value={dataAG.locationSignature}
                  type="text"
                  disabled
                />
              </Form.Group>
            </Form>
            <div className={`${styles.containerTtd}`}>
              <div className={`${styles.sigContainer}`}>
                <img
                  className={`${styles.sigContainer}`}
                  src={`data:image/png;base64,${dataAG.imageSignature}`}
                />
              </div>
            </div>
        </Col>
      </Row>
    </div>
  );
  arrayString.push(stringAG);

  return [
    arrayString,
    <Modal centered show={showCamera} key={12345}>
      <div className={styles.videoStream}>
        <Webcam
          audio={false}
          mirrored={true}
          ref={webcamRef}
          screenshotFormat="image/jpeg"
        />
      </div>
      <div className={styles.containerButtonCamera}>
        <button onClick={capture}>
          <img src="/images/record.png" width="35" />
        </button>
        <button onClick={() => setShowCamera(false)}>
          <img src="/images/close.png" width="35" />
        </button>
      </div>
    </Modal>,
     <Modal centered show={showCanvas} key={123456}>
     <div className={styles.videoStream}>

        <SignatureCanvas
          ref={signRef}
          penColor="black"
          canvasProps={{className: styles.sigCanvas}}
          clearOnResize={false}
        />

     </div>
     <div className={styles.containerButtonCamera}>
       <button onClick={captureSign}>
         <img src="/images/checked.png" width="35" />
      </button>
       <button onClick={() => setShowCanvas(false)}>
         <img src="/images/close.png" width="35" />
       </button>
     </div>
   </Modal>
  ];
}

const onClickHeader = (event, idx) => {
  event.stopPropagation();
  event.preventDefault();
};

const Persetujuan = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { SPAJs } = useSelector((state) => state.SPAJs);
  const { CitySign } = useSelector((state) => state.CitySign);
  const Signature = useSelector((state) => state.Signature.Signature);
  const { Selfie } = useSelector((state) => state.Selfie);
  const { SPAJDetail } = useSelector((state) => state.SPAJsDetail);
  const [statusCustomer, setStatusCustomer] = useState("");
  const [isUnitLink, setIsUnitLink] = useState(0);
  const { DeviceId } = useSelector((state) => state.DeviceId);
  const [imageIndex, setImageIndex] = useState(null);
  const [signIndex, setSignIndex] = useState(null);
  const [imageSrc, setImageSrc] = useState([]);
  const [signSrc, setSignSrc] = useState([]);
  const [showIndex, setShowIndex] = useState(-1);
  const [showHide, setShowHide] = useState(false);
  const [showHideError, setShowHideError] = useState(false);
  const [showHideErrorNext, setShowHideErrorNext] = useState(false);
  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [errorMessageNext, setErrorMessageNext] = useState("");
  const [buttonLanjut, setButtonLanjut] = useState(false);
  const [dataCountTtd, setDataCountTtd] = useState([]);
  const [dataDisableKonfirmasi, setDataDisableKonfirmasi] = useState([]);
  const [listAccordion, setListAccordion] = useState([
    {
      index: 0,
      checked: false,
    },
    {
      index: 1,
      checked: false,
    },
    {
      index: 2,
      checked: false,
    },
    {
      index: 3,
      checked: false,
    }
  ]);
  let signatureTempNew = JSON.parse(JSON.stringify(Signature.dataSign));
  signatureTempNew = signatureTempNew.sort(
    (a, b) => parseInt(a.seq) - parseInt(b.seq)
  );

  const onClickCheckbox = (idx, event, setListAccordion, listAccordion) => {

    listAccordion[idx].checked = event.target.checked;
    //need to reclean supaya statenya update
    listAccordion = JSON.parse(JSON.stringify(listAccordion));

    setListAccordion(listAccordion);
  };

  useEffect(() => {
    window.scrollTo(-100,-100)
    setStatusCustomer(StatusCustomer(SPAJs.spajHeader.statusCustomer,SPAJs.spajHeader?.isUnitLink));
    setIsUnitLink(SPAJs.spajHeader?.isUnitLink);
    setDataCountTtd([]);
    setDataDisableKonfirmasi([]);

    let checkDataComplete = true;
    let isAnyConfirmation = false;
    signatureTempNew.forEach((element, index) => {
      if (element.clientCode !== "AG") {
        if (element.isDone == "1") {
          isAnyConfirmation = true;
        }
        setDataCountTtd((oldState) => ({
          ...oldState,
          [index]: {
            button: false,
          },
        }));
        setDataDisableKonfirmasi((oldState) => ({
          ...oldState,
          [index]: {
            button: false,
          },
        }));
        if (element.imageSignature == "") {
          checkDataComplete = false;
        }
        if (element.locationSignature == "") {
          checkDataComplete = false;
        }
        let dataSelfie = Selfie.dataSelfie.find(
          (row2) => element.clientNumber == row2.clientNumber
        );
        if (dataSelfie != null && dataSelfie != undefined) {
          if (dataSelfie.imageSelfie == "") {
            checkDataComplete = false;
          }
        }
      }
    });
    if (isAnyConfirmation) {
      listAccordion.forEach((e) => {
        e.checked = true;
      });
      setListAccordion(listAccordion);
      setShowIndex(0);
    }
    setButtonLanjut(checkDataComplete);
  }, [SPAJs, Signature, statusCustomer]);

  useEffect(() => {
    if (buttonLanjut) {
      listAccordion.forEach((e) => {
        e.checked = true;
      });
      setListAccordion(listAccordion);
    }
  }, [buttonLanjut, listAccordion]);

  // useEffect(() => {
  //   let data = {
  //     deviceId: `${DeviceId.deviceId}`,
  //     userName: `${SPAJDetail.dataSpaj.email}`,
  //     spajNumber: `${SPAJDetail.dataSpaj.spajNumber}`,
  //     apps: "sys",
  //   };
  //   dispatch(getIlustrationSignature(data))
  //     .then((res) => {
  //       setLoading(false);
  //     })
  //     .catch((err) => {
  //       setLoading(false);
  //     });
  //   dispatch(getSelfie(data))
  //     .then((res) => {
  //       setLoading(false);
  //     })
  //     .catch((err) => {
  //       setLoading(false);
  //     });
  // }, []);

  // const [widthss, heightss] = useWindowSize();

  const insertSignature = async (data) => {
    return await dispatch(insertIlustrationSignature(data));
  };

  const insertSelfieWrap = async (data) => {
    return await dispatch(insertSelfie(data));
  };

  const goCheckSelfieSignature = () => {
    let detailData = {
      deviceId: `${DeviceId.deviceId}`,
      userName: `${SPAJs.spajHeader?.userName}`,
      spajNumber: `${SPAJs.spajHeader?.spajNumber}`,
    };
  
    console.log(detailData)
    dispatch(checkSelfieSignature(detailData)).then((res) => {
      if (res.payload.status == "ERROR") {
        setShowHideErrorNext(true);
        setErrorMessageNext(res.payload.errMsg);
      } else {
        goToPembayaran();
      }
    });
  };

  const goToPembayaran = () => {
    if (statusCustomer == 4 && isUnitLink == 0) {
      let detailData = {
        deviceId: `${DeviceId.deviceId}`,
        userName: `${SPAJs.spajHeader?.userName}`,
        spajNumber: `${SPAJs.spajHeader?.spajNumber}`,
        agentStatus: "IPC",
        customerStatus: "C",
      };
      dispatch(updateStatusSpaj(detailData)).then((res) => {
        // UPDATE LOCAL STATUS CUSTOMER KE P
        dispatch(updateStatusCustomer("C"));
        navigate( "/pembayaran");
      });
    }

    else if(statusCustomer == 4 && isUnitLink == 1)
    {
      let detailData = {
        deviceId: `${DeviceId.deviceId}`,
        userName: `${SPAJs.spajHeader?.userName}`,
        spajNumber: `${SPAJs.spajHeader?.spajNumber}`,
        agentStatus: "IPC",
        customerStatus: "P",
      };
      dispatch(updateStatusSpaj(detailData)).then((res) => {
        // UPDATE LOCAL STATUS CUSTOMER KE P
        dispatch(updateStatusCustomer("P"));
        if (SPAJs.spajHeader?.isUnitLink == 0) navigate( "/pembayaran")
        else navigate( '/final-step')
      });
    }
    else
    {
      if (SPAJs.spajHeader?.isUnitLink == 0) navigate( "/pembayaran")
      else navigate( '/final-step')

    }
  };

  const navigatePage = () => {
    // if (SPAJs.spajHeader.isLogin === "1") {
    //     console.log("IS LOGIN");
    // } else {
    navigate( "/ilustrasi");
    // }
  };

  function checkString(data) {
    return /[a-z]/i.test(data);
  }

  function ReturnDataSPAJ({ data }) {
        console.log("ReturnDataSPAJ",data)

    let arrayString = [];

    data.forEach((row, index) => {
      if (row.MPHS_LabelSequenceNo == 0) {
        arrayString.push(<p key={index} style={{ textAlign: 'justify' }}>{row.MPHS_Statement}</p>);
      } else if (checkString(row.MPHS_LabelSequenceNo)) {
        if (row.MPHS_StatementType == "IT_TXT") {
          let string = (
            <div
              key={index}
              className="d-flex flex-row justify-content-between align-items-start"
            >
              <Form style={{ width: "40%" }}>
                <Form.Label>{row.MPHS_Statement}</Form.Label>
              </Form>
              <p style={{ width: "55%" }}>
                <Form.Control
                  value={`${row.TRPS_Answer}`}
                  disabled
                  type="text"
                />
              </p>
            </div>
          );
          arrayString.push(string);
        } else if (row.MPHS_StatementType == "IT_CHK") {
          let string = (
            <div
              key={index}
              className="d-flex flex-row justify-content-start align-items-start"
            >
              <Form>
                <Form.Check
                  key="default-checkbox"
                  className=" mt-3 mb-3 me-2"
                  disabled
                  type="checkbox"
                  id="default-checkbox"
                  checked={row.TRPS_Answer == "Y"}
                />
              </Form>
              <p style={{ textAlign: 'justify' }}>{row.MPHS_Statement}</p>
            </div>
          );
          arrayString.push(string);
        }
      } else {
        arrayString.push(
          <p key={index} style={{ textAlign: 'justify' }}>
            {row.MPHS_LabelSequenceNo}. {row.MPHS_Statement}
          </p>
        );
      }
    });

    return arrayString;
  }

  function ReturnDataAdditionalStatement({ data }) {
    console.log("ReturnDataAdditionalStatement",data)
    let arrayString = [];

    data.forEach((row, index) => {
      if (row.MAST_LabelSequenceNo == 0) {
        arrayString.push(<p key={index} style={{ textAlign: 'justify' }}>{row.MPHS_Statement}</p>);
      } else if (checkString(row.MAST_LabelSequenceNo)) {
        
          let string = (
            <div
              key={index}
              className="d-flex flex-row justify-content-start align-items-start"
              style={{ marginLeft: '20px' }}
            >
              <p key={index} style={{ textAlign: 'justify' }}>
                {row.MAST_LabelSequenceNo}. {row.MAST_Statement}
              </p>
            </div>
          );
          arrayString.push(string);

      } else {
        arrayString.push(
          <p key={index} style={{ textAlign: 'justify' }}>
            {row.MAST_LabelSequenceNo}. {row.MAST_Statement}
          </p>
        );
      }
    });

    return arrayString;
  }

  function handleHeader(key) {
    if (key == 0 || listAccordion[key - 1].checked == true) {
    //   if (key > 0) console.log("key", key, listAccordion[key - 1].checked);
      setShowIndex(key);

      setTimeout(function () {
        window.scrollTo(-100,-100)
      },200);
    }
  }

  return (
    <>
      {statusCustomer < 4 &&<LockScreen/>}
      {loading == true && <Spinners />}
      <div>
        <Header />
        <div className="g-0">
          <div className={styles.bgContainer}>
          <ProgressBar step="3" status={statusCustomer} isUnitlink={isUnitLink}/>
            <div className={styles.allCardGreyPesetujuan}>
              <div className={styles.cardContainer}>
                <Accordion defaultActiveKey={["0"]}>
                  <Accordion.Item eventKey="0">
                    <Card.Header
                      onClick={(event) => handleHeader(0)}
                      className={
                        showIndex == 0
                          ? `${styles.cardHeaderOn}`
                          : `${styles.cardHeader}`
                      }
                    >
                      Tahap 1: Syarat dan Ketentuan Ilustrasi
                      {showIndex == 0 ? (
                        <img src={"/images/minus.png"} width={15} height={15} />
                        ):(
                          <img src={"/images/plus.png"} width={15} height={15} />
                          )
                        }
                    </Card.Header>
                    {showIndex === 0 && (
                      <Accordion.Body className={styles.contentBody}>
                        {SPAJs.spajHeader.isUnitLink == 1 && (
                          <>
                            <p>Khusus untuk Dana Investasi Anda:</p>
                            {SPAJDetail.dataBenefitSpaj.profilDetail.map(
                              (profDetail, index) => (
                                <>
                                  <div key={profDetail.AnswerId}>
                                    <p>
                                      {" "}
                                      {index + 1} . {profDetail.Question}
                                    </p>
                                    <p>
                                      <b>Jawaban: {profDetail.Answer}</b>
                                    </p>
                                  </div>
                                </>
                              )
                            )}
                            <div>
                              <p>
                                Berdasarkan Jawaban di atas,Anda termasuk dalam
                                kategori Risiko{" "}
                                <b>
                                  {
                                    SPAJDetail.dataBenefitSpaj?.profilHeader
                                      .LongDescFinal
                                  }
                                </b>
                              </p>
                              {SPAJDetail.dataBenefitSpaj.funds.map(
                                (investType, index) => (
                                  <>
                                    <p key={index}>
                                      <b>
                                        Fasilitas Investasi:{" "}
                                        {investType.InvestTypeDesc}
                                      </b>{" "}
                                    </p>
                                  </>
                                )
                              )}
                            </div>
                          </>
                        )}

                        {SPAJDetail.dataBenefitSpaj.funds.map((fundsRoboArms) =>
                          fundsRoboArms.RoboArms == "Y"
                            ? SPAJDetail.ArmsStatementIllustrasi.map(
                                (armState, i) =>
                                  armState.MILS_SequenceNo == 1 ? (
                                    <>
                                      <div
                                        className={`d-flex flex-row justify-content-start align-items-start`}
                                      >
                                        <div style={{ width: 30 }}>
                                          <Form>
                                            <Form.Check
                                              key={`default-checkbox`}
                                              className=" mt-3 mb-3"
                                              disabled
                                              type={"checkbox"}
                                              id={`default-checkbox`}
                                              checked
                                            />
                                          </Form>
                                        </div>
                                        <div style={{ width: "95%" }}>
                                          <p>{armState.MILS_Statement}</p>
                                        </div>
                                      </div>
                                    </>
                                  ) : armState.MILS_SequenceNo == 2 ? (
                                    <div>
                                      <p>{armState.MILS_Statement}</p>
                                    </div>
                                  ) : (
                                    <div>
                                      <p key={i}>
                                        {i - 1}.{armState.MILS_Statement}
                                      </p>
                                    </div>
                                  )
                              )
                            : (SPAJDetail.NonArmstatementIllustrasi.map(
                                (nonArmState, i) => {
                                  <p key={i} >
                                    {nonArmState.MILS_SequenceNo}.{" "}
                                    {nonArmState.MILS_Statement}
                                  </p>;
                                }
                              ),
                              (
                                <>
                                  <p>{fundsRoboArms.FundDesc}: {fundsRoboArms.Amount}%</p>
                                </>
                              ))
                        )}
                        <b style={{ marginLeft: "10px" }}>Disclaimer</b>
                        {SPAJDetail.DisclaimerStatementIllustrasi.map(
                          (detailIlustrasi, i) => (
                            <p key={i} style={{ textAlign: 'justify' }}>
                              {detailIlustrasi.MILS_LabelSequenceNo}.{" "}
                              {detailIlustrasi.MILS_Statement}{" "}
                            </p>
                          )
                        )}
                        <Form>
                          <Form.Check
                            key={`default-checkbox`}
                            className=" mt-3 mb-3"
                            onChange={(event) =>
                              onClickCheckbox(
                                0,
                                event,
                                setListAccordion,
                                listAccordion
                              )
                            }
                            // disabled
                            type={"checkbox"}
                            checked={listAccordion[0]?.checked}
                            id={`default-checkbox`}
                            label={(<><b>Saya telah membaca dan memahami Syarat dan Ketentuan diatas</b></>)}
                          />
                        </Form>
                      </Accordion.Body>
                    )}
                  </Accordion.Item>
                  <Accordion.Item eventKey="1">
                    <Card.Header
                      onClick={() => handleHeader(1)}
                      className={
                        showIndex == 1
                          ? `${styles.cardHeaderOn}`
                          : `${styles.cardHeader}`
                      }
                    >
                      Tahap 2: Syarat dan Ketentuan SPAJ
                      {showIndex == 1 ? (
                        <img src={"/images/minus.png"} width={15} height={15} />
                        ):(
                          <img src={"/images/plus.png"} width={15} height={15} />
                          )
                        }
                    </Card.Header>
                    {showIndex === 1 && (
                      <Card.Body
                        className={[styles.accordionBody, styles.contentBody]}
                      >
                        <ReturnDataSPAJ data={SPAJDetail.PHStatement} />
                        <Form>
                          <Form.Check
                            key={`default-checkbox`}
                            className=" mt-3 mb-3"
                            onChange={(event) =>
                              onClickCheckbox(
                                1,
                                event,
                                setListAccordion,
                                listAccordion
                              )
                            }
                            // disabled
                            type={"checkbox"}
                            id={`default-checkbox`}
                            label={(<><b>Saya telah membaca dan memahami Syarat dan Ketentuan diatas</b></>)}
                            checked={listAccordion[1]?.checked}
                          />
                        </Form>
                      </Card.Body>
                    )}
                  </Accordion.Item>
                  <Accordion.Item eventKey="2">
                    <Card.Header
                      onClick={() => handleHeader(2)}
                      className={
                        showIndex == 2
                          ? `${styles.cardHeaderOn}`
                          : `${styles.cardHeader}`
                      }
                    >
                      Tahap 3: Persetujuan Data Konsumen dan Dokumen Permohonan
                      {showIndex == 2 ? (
                        <img src={"/images/minus.png"} width={15} height={15} />
                        ):(
                          <img src={"/images/plus.png"} width={15} height={15} />
                          )
                        }
                    </Card.Header>
                    {showIndex === 2 && (
                      <Card.Body
                        className={[styles.accordionBody, styles.contentBody]}
                      >
                        <ReturnDataAdditionalStatement data={SPAJDetail.dataAdditionalStatement} />
                        <Form>
                          <Form.Check
                            key={`default-checkbox`}
                            className=" mt-3 mb-3"
                            onChange={(event) =>
                              onClickCheckbox(
                                2,
                                event,
                                setListAccordion,
                                listAccordion
                              )
                            }
                            // disabled
                            type={"checkbox"}
                            id={`default-checkbox`}
                            label={(<><b >Saya/Kami menyatakan bahwa telah membaca, memahami, dan menyetujui ketentuan tersebut di atas terkait dengan Informasi Konsumen dan Dokumen Permohonan.</b></>)}
                            checked={listAccordion[2]?.checked}
                          />
                        </Form>
                      </Card.Body>
                    )}
                  </Accordion.Item>
                  <Accordion.Item eventKey="3">
                    <Card.Header
                      onClick={() => handleHeader(3)}
                      className={
                        showIndex == 3
                          ? `${styles.cardHeaderOn}`
                          : `${styles.cardHeader}`
                      }
                    >
                      Tahap 4: Kolom Persetujuan
                      {showIndex == 3 ? (
                        <img src={"/images/minus.png"} width={15} height={15}/>
                        ):(
                          <img src={"/images/plus.png"} width={15} height={15}/>
                          )
                        }
                    </Card.Header>
                    {showIndex === 3 && (
                      <Card.Body
                        className={[styles.accordionBody, styles.contentBody]}
                      >

                        <Form>
                          <Form.Check
                            key={`default-checkbox`}
                            className=" mt-3 mb-3"
                            onChange={(event) =>
                              onClickCheckbox(
                                3,
                                event,
                                setListAccordion,
                                listAccordion
                              )
                            }
                            // disabled
                            type={"checkbox"}
                            checked={listAccordion[3]?.checked}
                            id={`default-checkbox`}
                            label={isUnitLink == 1 ? (<><b>Dengan menandatangani SPAJ elektronik ini,  maka Saya telah setuju terhadap setiap informasi, detil dan/atau pernyataan yang ada dalam Ringkasan Informasi Produk dan Layanan (RIPLAY) Personal, Formulir Halaman Pernyataan SPAJ, dan Formulir Pernyataan Pemahaman Produk Asuransi yang Dikaitkan dengan Investasi (PAYDI). Saya memahami bahwa setiap informasi, detil dan/atau pernyataan sebagaimana dimaksud dalam hal ini adalah satu kesatuan yang tidak terpisahkan dari SPAJ elektronik ini.</b></>) : 
                              (<><b>Dengan menandatangani SPAJ elektronik ini,  maka Saya telah setuju terhadap setiap informasi, detil dan/atau pernyataan yang ada dalam Ringkasan Informasi Produk dan Layanan (RIPLAY) Personal, Formulir Halaman Pernyataan SPAJ, dan Formulir Pernyataan Pemahaman Produk Asuransi. Saya memahami bahwa setiap informasi, detil dan/atau pernyataan sebagaimana dimaksud dalam hal ini adalah satu kesatuan yang tidak terpisahkan dari SPAJ elektronik ini.</b></>)}
                          />
                        </Form>
                        {listAccordion[3].checked == true ? ( 
                        <ReturnDataTTD
                          dataSignature={signatureTempNew}
                          dataSelfie={Selfie.dataSelfie}
                          setImageIndex={setImageIndex}
                          imageIndex={imageIndex}
                          setImageSrc={setImageSrc}
                          imageSrc={imageSrc}
                          insertSignature={insertSignature}
                          insertSelfieWrap={insertSelfieWrap}
                          setLoading={setLoading}
                          setErrorMessage={setErrorMessage}
                          setShowHide={setShowHide}
                          setShowHideError={setShowHideError}
                          setButtonLanjut={setButtonLanjut}
                          buttonLanjut={buttonLanjut}
                          dataCountTtd={dataCountTtd}
                          setDataCountTtd={setDataCountTtd}
                          dataDisableKonfirmasi={dataDisableKonfirmasi}
                          setDataDisableKonfirmasi={setDataDisableKonfirmasi}
                          setSignIndex={setSignIndex}
                          signIndex={signIndex}
                          signSrc={signSrc}
                          setSignSrc={setSignSrc}
                        />
                        ) : null}
                       
                      </Card.Body>
                    )}
                  </Accordion.Item>
                </Accordion>
                {showIndex == -1 ?(
                   <div className={`position-relative`} style={{height: 40,marginBottom: 5,marginTop: 50}}>
                   <div className={styles.pbotton}>
                     <div style={{ display: "flex" }}>
                         <button className={styles.buttonWarning} >Mohon persetujuan diberikan sesuai tahapan diatas</button>
                     </div>      
                   </div>          
                 </div>
                ) : null }
               {console.log("buttonLanjut",buttonLanjut)}
              </div>
              <div className={`position-relative`} style={{height: 40,marginBottom: 30,marginTop: 30}}>
                <div className={styles.pbotton}>
                  <div style={{ display: "flex" }}>
                    <div>
                    <button className={styles.buttonkembali} onClick={() => navigate( "/form-final-step")}>Kembali</button>
                    </div>
                    <div>
                        <button
                          className={
                            buttonLanjut
                              ? `${styles.buttonnext}`
                              : `${styles.buttonnextDisable}`
                          }
                          disabled={!buttonLanjut}
                          onClick={() => goCheckSelfieSignature()}
                        >
                          Selanjutnya
                        </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className={styles.linkFooter}>
              <div>www.generali.co.id</div>
            </div>
          </div>
        </div>
      </div>
      <Modal dialogClassName={styles.modalcustom} centered show={showHide}>
        <Modal.Body>
          <div className="d-flex flex-column justify-content-center align-items-center">
          <p className="fs-15 text-center">Konfirmasi data berhasil</p>
            {/* <p className="fs-15 text-center">Pengambilan foto berhasil</p> */}
              <div>
                <button className={styles.buttonkembalimodal} onClick={() => setShowHide(false)}>OK</button>
              </div>
          </div>
        </Modal.Body>
      </Modal>

      <Modal dialogClassName={styles.modalcustom} centered show={showHideError}>
        <Modal.Body>
          <div className="d-flex flex-column justify-content-center align-items-center">
            {/* <p className="fs-15 text-center">Gagal Konfirmasi. {errorMessage}</p> */}
            {/* <p className="fs-15 text-center">Pengambilan foto tidak berhasil. Pastikan jaringan seluler Anda dalam kondisi baik dan wajah Anda terlihat jelas saat pengambilan foto.</p> */}
            <p className="fs-15 text-center">{`${errorMessage === '' ? `Error Konfirmasi data tidak berhasil. Pastikan jaringan seluler Anda dalam kondisi baik dan wajah Anda terlihat jelas saat pengambilan foto.` : `Gagal Konfirmasi. `+errorMessage} `}</p>
              <div>
                <button className={styles.buttonkembalimodal} onClick={() => setShowHideError(false)}>OK</button>
              </div>
          </div>
        </Modal.Body>
      </Modal>

      <Modal dialogClassName={styles.modalcustom} centered show={showHideErrorNext}>
        <Modal.Body>
          <div className="d-flex flex-column justify-content-center align-items-center">
            {/* <p className="fs-15 text-center">Gagal Konfirmasi. {errorMessage}</p> */}
            {/* <p className="fs-15 text-center">Pengambilan foto tidak berhasil. Pastikan jaringan seluler Anda dalam kondisi baik dan wajah Anda terlihat jelas saat pengambilan foto.</p> */}
            <p className="fs-15 text-center">{`${errorMessageNext === '' ? `Periksa Kembali Tanda Tangan dan atau selfie anda !` : errorMessageNext} `}</p>
              <div>
                <button className={styles.buttonkembalimodal} onClick={() => {setShowHideErrorNext(false); window.location.reload();}}>OK</button>
              </div>
          </div>
        </Modal.Body>
      </Modal>

    </>
  );
};

export default Persetujuan;